import axios from 'axios'
import qs from 'qs'
import Url from './url'
// import cookie from './cookie'
import store from '../vuex'
// import router from '../router'
// 请求拦截
axios.interceptors.request.use(config => {
  let token = window.vm.$store.state.token || null
  // var token = cookie.token() || null
  if (token) {
    token = `${token}`
    config.headers['Authorization'] = token // 配置请求头中  Authorization 字段的值为拿到的token
  }
  return config
})
// 响应时拦截
axios.interceptors.response.use(function (response) {
  if (Number(response.data.errorCode) === 0) {
    // 成功
    return response.data
  } else if (Number(response.data.errorCode === 400902)) {
    // 未登录
    window.vm.$msg(response.data.errorMsg || '未登录')
    // 清除登录信息
    store.commit('LOSELOGIN')
    return false
  } else if (Number(response.data.errorCode === 400415)) {
    // 答中雷题
    // window.vm.$msg(response.data.errorMsg)
    return response.data
  } else {
    // 普通错误处理
    window.vm.$msg(response.data.errorMsg, 'error')
    return false
  }
}, function (error) {
  // 当响应异常时做一些处理
  // alert(error)
  console.log(error)
  if (error.response.status === 401) {
    let data = error.response.data || {}
    window.vm.$msg(data.detail || '未登陆')
    store.commit('LOSELOGIN')
    // router.push({ path: '/login' })
  } else {
    alert(error)
  }
  return Promise.reject(error)
})

export default {
  // 公共参数
  prodata (data) {
    var pubdata = {
      ...data
    }
    // _arr.data = JSON.stringify(pubdata)
    return pubdata
  },
  post (url, data) {
    var Data = this.prodata(data)
    // console.log(data)
    var isUrl = Url.api
    return axios({
      method: 'post',
      baseURL: isUrl,
      url,
      // data: qs.stringify(data),
      data: Data,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  postQs (url, data) {
    // var Data = this.prodata(data)
    var isUrl = Url.api
    return axios({
      method: 'post',
      baseURL: isUrl,
      url,
      data: qs.stringify(data),
      // data: data,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  postJson (url, data) {
    var Data = this.prodata(data)
    var isUrl = Url.api
    return axios({
      method: 'post',
      baseURL: isUrl,
      url,
      data: Data,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json'
      }
    })
  },
  postForm (url, data) {
    var Data = this.prodata(data)
    var isUrl = Url.api
    return axios({
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      method: 'post',
      baseURL: isUrl,
      url,
      data: Data,
      timeout: 10000
    })
  },
  get (url, params) {
    var Data = this.prodata(params)
    return axios({
      method: 'get',
      baseURL: Url.api,
      url,
      params: Data, // get 请求时带的参数
      timeout: 10000,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/config/http.js